import {
    Typography,
    Box,
    Button,
    Container,
    Card,
    CardContent,
    Grid,
    IconButton,
    DialogContent
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import { AuthContext } from 'components/lib';
import { useContext } from 'react';

export function PaymentDialog({
    showUpgradePlan,
    handleCloseUpgradePlan,
    onUpgradePlan,
    plans
}) {
    const authContext = useContext(AuthContext);
    const currencySymbol = authContext?.user?.currencySymbol || ''

    return (
        <Dialog
            id='upgradPlanDialog'
            open={showUpgradePlan}
            PaperProps={{
                sx: {
                    width: "60vw",
                    maxWidth: "60vw",
                    maxHeight: "100vh",
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: "rgba(0,0,0,0.35)",
                        backdropFilter: "blur(6px)",
                    },
                },
            }}
        >
            <Box sx={{ bgcolor: 'grey.50', minHeight: '100%', py: 2, px: 2, borderRadius: '8px' }}>
                <Container maxWidth="lg">
                    {/* Header */}
                    <IconButton
                        id="closeButton"
                        size="small"
                        onClick={() => handleCloseUpgradePlan()}
                        aria-label="Close"
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Box sx={{ textAlign: 'center', mb: 6 }}>
                        <Typography variant="h4" component="h1" fontWeight="bold" sx={{ color: '#1450a0' }} gutterBottom>
                            Choose Your Plan
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Select the plan that works best for you
                        </Typography>
                    </Box>
                    {/* Plans Grid */}
                    <DialogContent dividers sx={{ p: 1 }}>
                        <Grid container spacing={3}>
                            {plans?.map((plan, index) => (
                                <Grid item xs={12} key={index}>
                                    <Card
                                        sx={{
                                            border: "2px solid #e5e7eb",
                                            "&:hover": {
                                                borderColor: "green",
                                                boxShadow: 4,
                                            },
                                            borderRadius: 3,
                                            transition: "0.5s",
                                            width: "100%",
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                width: "100%",
                                            }}
                                        >
                                            {/* Left Side */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "100%"
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        flexDirection: 'row',
                                                        gap: 4,
                                                        cursor: 'default'
                                                    }}
                                                >
                                                    <Box textAlign="center">
                                                        <Typography
                                                            variant="h5"
                                                            sx={{ color: '#1450a0', fontWeight: "bold" }}
                                                        >
                                                            {plan?.meta_data?.attempts}
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Sessions
                                                        </Typography>
                                                    </Box>

                                                    <Box
                                                        textAlign="center"
                                                        sx={{ display: 'flex', alignItems: 'center', gap: 2 }} >
                                                        <Typography variant="h4" fontWeight="bold">
                                                            {currencySymbol}{plan?.price}
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                textDecoration: 'line-through',
                                                                color: 'text.secondary',
                                                                fontSize: '17px'
                                                            }}
                                                        >
                                                            {currencySymbol}{plan.actual_price}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                {/* Buy Button */}
                                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                    <Button
                                                        color="success"
                                                        sx={{
                                                            fontWeight: 500,
                                                            fontSize: '15px',
                                                            borderRadius: '16px',
                                                            color: '#ffffff',
                                                            bgcolor: '#008037',
                                                            '&:hover': {
                                                                bgcolor: '#39a96a',
                                                            },
                                                            width: '150px',
                                                            height: '50px',
                                                        }}
                                                        onClick={() => { onUpgradePlan(plan) }}
                                                    >
                                                        Buy
                                                    </Button>
                                                </Box>
                                            </Box>


                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </DialogContent>
                </Container>
            </Box>
        </Dialog >
    )
}